import apiProvider from './utilities/provider'

const url = 'local-candidates'

const apiCandidates = {
  getParsedProfileInfoFromToken: (token) =>
    apiProvider.getSingle(url, `${token}/get-parsed-data`),

  updateParsedProfileInfo: (token, data) =>
    apiProvider.patch(url, `${token}/update-parsed-data`, data),

  getDocumentsByToken: (candidateId, token) =>
    apiProvider.getSingle(url, `${candidateId}/docs-by-token/${token}`),

  updateDocumentsWithToken: (candidateId, data) =>
    apiProvider.post(`${url}/${candidateId}/docs-by-token`, data),
}

export default apiCandidates
